import { useQuery } from "@tanstack/react-query";
import fetchApi from "../fetchApi";
import { ThemeProps } from "../../models/theme";

const useQueryGroupTheme = ({
  id,
  groupType,
  enable = true,
  authorisation = "",
}: {
  id: any;
  groupType: string;
  enable?: boolean;
  authorisation: string;
}) => {
  return useQuery(
    [`${groupType}`],
    () =>
      fetchApi(`theme/${id}/${groupType}`, {
        headers: {
          Authorization: `Bearer ${authorisation}`,
        },
      }).get<ThemeProps>(),
    {
      staleTime: 1000 * 60 * 10,
      refetchOnWindowFocus: false,
      enabled: enable,
    }
  );
};

export default useQueryGroupTheme;
